import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

import { Crud, CrudService, ConfigServerService, CustomHttp } from '../../../core';
import { Pedido } from '../pedido';
import { map } from 'rxjs/operators';
import { PedidoDRP, PedidoItemDRP } from '../drp';
import { CanalVenda } from '../../common/canais-venda/domain';

@Injectable({
    providedIn: 'root'
})
export class PedidoCrudHttpService implements Crud<Pedido> {
    resource = 'pedido';
    private pathApi: string;

    constructor(configServerService: ConfigServerService,
                private crudService: CrudService,
                private customHttp: CustomHttp) {
        this.pathApi = `${configServerService.getPathApi()}/${this.resource}`;
    }

    /** Pesquisa todos os pedidos cadastrados */
    search(): Observable<Pedido[]> {
        return this.crudService.search<Pedido>(this.resource);
    }

    // searchWithFilter(filter: PedidoFilterSearch, drawDatatable: number, offset: number, limit: number, orderBy: number, orderByDir: string): Observable<PedidoSearchAsync> {
    //     // Params
    //     let params = new HttpParams()
    //                         .append('drawDatatable', drawDatatable.toString())
    //                         .append('offset', offset.toString())
    //                         .append('limit', limit.toString())
    //                         .append('orderBy', orderBy.toString())
    //                         .append('orderByDir', orderByDir ? orderByDir : '');
    //     // Filter params
    //     if (filter) {
    //         params = filter.createParams(params);
    //     }

    //     return this.customHttp.get<PedidoSearchAsync>(this.pathApi, {params: params});
    // }

    /** Procura um único pedido através do seu ID */
    find(id: number): Observable<Pedido> {
        return this.crudService.find<Pedido>(this.resource, id);
    }

    /** Carrega um único pedido através do seu ID */
    load(id: number, isConfirmando = false): Observable<Pedido> {
         // Params
         const params = new HttpParams()
                            .append('isConfirmando', isConfirmando.toString());

        return this.crudService.load<Pedido>(this.resource, id, {params})
                    .pipe(
                        map(pedido => {
                            // Canal de Venda
                            pedido.canalVenda = CanalVenda.getById(pedido.idCanalVenda);

                            // Criando o objeto do D.R.P.
                            if (pedido.drp) {
                                pedido.drp = Object.assign(new PedidoDRP(), pedido.drp);
                            }

                            // Itens
                            pedido.itens?.forEach(pedidoItem => {
                                // Criando o objeto do D.R.P.
                                if (pedidoItem.drp) {
                                    pedidoItem.drp = Object.assign(new PedidoItemDRP(), pedidoItem.drp);
                                }
                            });

                            return pedido;
                        })
                    );
    }

    /** Insere um novo pedido */
    insert(entity: Pedido): Observable<Pedido> {
        return this.crudService.insert<Pedido>(this.resource, entity);
    }

    /** Altera um pedido existente */
    update(entity: Pedido): Observable<Pedido> {
        return this.crudService.update<Pedido>(this.resource, entity);
    }

    /** Exclui um pedido através do seu ID */
    delete(id: number): Observable<string> {
        return this.crudService.delete(this.resource, id);
    }
}
